var view = require('./addressSearchView');
var ajaxWrapper = require('./ajaxWrapper');

function findAddresses(postcode) {
    "use strict";
    ajaxWrapper.call({
        dataType: "html",
        url: "/ajax-calls/addresses?postcode=" + postcode,
        success: function (addresses) {
            view.hidePostcodeSearchError();
            view.hideUnrecognisedPostcodeError();
            view.showAddresses(addresses);
            view.hidePostcodeSearchForm();
            view.removeSpinnerForFindAddressButton();
        },
        failure: function (error) {
            view.removeSpinnerForFindAddressButton();

            if (error.status === 400) {
                view.showUnrecognisedPostcodeError();
            }
            else {
                switchToManualAddressEntry();
                view.showPostcodeSearchError();
            }
        }
    });
}

function getStructuredAddress(addressId) {
    "use strict";
    ajaxWrapper.call({
        dataType: "json",
        url: "/ajax-calls/addresses/" + addressId,
        success: function (selectedAddress) {
            showSelectedAddress(selectedAddress);
            view.resetAddressErrors();
        },
        failure: function () {
            switchToManualAddressEntry();
            view.showPostcodeSearchError();
        }
    });
}

function searchAgainAndClearResults() {
    "use strict";
    var defaultCountry = "United Kingdom";
    var emptyAddress = {"addressLine1": "", "addressLine2": "", "city": "", "postcode": "", "country": defaultCountry};

    view.populateManualAddressEntryFields(emptyAddress);
    switchToPostcodeSearch();
}

function showSelectedAddress(address) {
    "use strict";
    switchToManualAddressEntry();
    view.populateManualAddressEntryFields(address);
    view.populateHiddenAddressEntryFields(address);
}

function switchToPostcodeSearch() {
    "use strict";
    view.hideManualAddressEntry();
    view.hideSearchAddressLink();
    view.hidePostcodeSearchResults();
    view.showPostcodeSearch();
}

function switchToManualAddressEntry() {
    "use strict";
    view.copyPostcodeToManualEntry();
    view.hidePostcodeSearch();
    view.hidePostcodeSearchResults();
    view.showManualAddressEntry();
    view.showSearchAddressLink();
}

function submitPostcodeSearchOnEnterKeyEvent(e) {
    "use strict";
    var enterKeyKeyCode = 13;
    var shouldSubmitSearch = (e.key === enterKeyKeyCode || e.keyCode === enterKeyKeyCode || e.which === enterKeyKeyCode || e.charCode === enterKeyKeyCode);
    if (shouldSubmitSearch) {
        onPostcodeSearchRequested();
        return false;
    }
    return true;
}

function onPostcodeSearchRequested() {
    "use strict";
    view.validatePostcode();
    if (view.isPostcodeSearchValueInAValidFormat()) {
        view.addSpinnerForFindAddressButton();
        findAddresses(view.postcodeSearchValue());
    }
}

function initialize() {
    "use strict";
    view.onAddressEntryClicked(getStructuredAddress);
    view.onEnterKeyPressedInPostcodeSearch(submitPostcodeSearchOnEnterKeyEvent);
    view.onManualAddressEntryClicked(switchToManualAddressEntry);
    view.onPostCodeSearch(onPostcodeSearchRequested);
    view.onSearchAddressClicked(searchAgainAndClearResults);

    if(view.showPostcodeSearchOnLoad()) {
        switchToPostcodeSearch();
    } else {
        switchToManualAddressEntry();
    }
}

module.exports = {
    initialize: initialize,
    switchToManualAddressEntry: switchToManualAddressEntry
};